/* 🤖 this file was generated by script */
export const wsolidiconMessageDotsCircle = {
  name: 'message_dots_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 2a10 10 0 0 0-9.18 13.97V16l-.03.18-.6 3.59-.07.5c0 .17-.01.44.11.72q.24.55.79.79c.28.12.55.12.72.1q.25-.01.5-.06l3.59-.6.18-.03h.02l.2.09Q10 21.99 12 22a10 10 0 0 0 0-20M6 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m4.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
